<svg
  class="hide-safari"
  width="19"
  height="21"
  viewBox="0 0 19 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M17.7 2.45C15.15 1.4 12.525 0.875 9.825 0.875C7.125 0.875 4.425 1.4 1.95 2.45C1.2 2.75 0.75 3.425 0.75 4.25V10.55C0.75 14.975 3.6 18.95 7.725 20.45L8.625 20.75C9 20.9 9.45 20.975 9.825 20.975C10.2 20.975 10.575 20.9 11.025 20.75L11.925 20.45C16.05 18.95 18.9 14.975 18.9 10.55V4.25C18.9 3.5 18.45 2.75 17.7 2.45ZM17.325 10.55C17.325 14.3 14.925 17.75 11.325 19.025L10.425 19.325C10.05 19.475 9.6 19.475 9.15 19.325L8.25 19.025C4.725 17.75 2.25 14.3 2.25 10.55V4.25C2.25 4.025 2.4 3.875 2.55 3.8C4.875 2.825 7.275 2.375 9.825 2.375C12.3 2.375 14.775 2.825 17.025 3.8C17.175 3.875 17.325 4.025 17.325 4.25V10.55Z"
    fill="#005095"
  />
  <path
    d="M12.4501 7.9252L8.6251 11.7502L7.5001 10.6252C7.2001 10.3252 6.7501 10.3252 6.4501 10.6252C6.1501 10.9252 6.1501 11.3752 6.4501 11.6752L7.7251 12.9502C7.9501 13.1752 8.3251 13.3252 8.6251 13.3252C9.0001 13.3252 9.3001 13.1752 9.5251 12.9502L13.5001 8.9752C13.8001 8.6752 13.8001 8.2252 13.5001 7.9252C13.2001 7.6252 12.7501 7.6252 12.4501 7.9252Z"
    fill="#005095"
  />
</svg>
<img
  src="assets/SVG/acmic-myinsurance-filled.png"
  width="20"
  height="24"
  class="show-safari"
  alt="Dashboard"
/>
